import { createAction } from '@reduxjs/toolkit'
import { Hint, Instance, Integration, Session, Topic } from '../../types/data'

export const setTopics = createAction<Topic[]>('data/setTopics')
export const setSelectedHint = createAction<Hint | undefined>('data/setSelectedHint')
export const setCurrentSession = createAction<Session>('data/setCurrentSession')
export const setCurrentInstance = createAction<Instance>('data/setCurrentInstance')
export const setIntegrations = createAction<Integration[]>('data/setIntegrations')
